import { render, staticRenderFns } from "./truckButton.vue?vue&type=template&id=00d6b2ce&scoped=true"
import script from "./truckButton.vue?vue&type=script&lang=js"
export * from "./truckButton.vue?vue&type=script&lang=js"
import style0 from "./truckButton.vue?vue&type=style&index=0&id=00d6b2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d6b2ce",
  null
  
)

export default component.exports